import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

/**
 * Renders an SVG icon at a specific pixel size, solving the common mismatch
 * between an SVG's viewBox dimensions and the desired render size.
 *
 * Without this, every Isvg usage needs a dedicated CSS class just to control
 * width/height, and SVGs whose viewBox is larger than the intended render size
 * (e.g. a 24×24 viewBox for a visually 20×20 icon) appear too small.
 */
const SvgIcon = ({ src, size, width, height, className, color, ...rest }) => {
  const w = width || size;
  const h = height || size;

  const style = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: w,
    height: h,
    flexShrink: 0,
    ...(color ? { color } : {}),
  };

  return <Isvg src={src} className={className} style={style} {...rest} />;
};

SvgIcon.propTypes = {
  src: PropTypes.string.isRequired,
  size: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  color: PropTypes.string,
};

SvgIcon.defaultProps = {
  size: 20,
};

export default SvgIcon;
